import JourneyOfferList from '@/components/purchase/journey/JourneyOfferList';
import { getManageFlowBookingById } from '@/features/manage/manageActions';
import {
  setSelectedInboundOfferMapByLegId,
  startExchange,
  updateSelectedInboundOfferMapByLegId,
} from '@/features/purchase/purchaseActions';
import {
  inboundDataSelector,
  selectedInboundOfferMapSelector,
} from '@/features/purchase/purchaseSelectors';
import { useBookingCreation } from '@/hooks/useBookingCreation';
import { useChangeBookingSelection } from '@/hooks/useChangeBookingSelection';
import { TransAlert } from '@/i18n/trans/alert';
import { TransText } from '@/i18n/trans/text';
import { useDispatch, useSelector } from '@/store/utils';
import type { ApiErrorResponse } from '@/types/api';
import { GTM_EVENT, trackCustomEvent } from '@/utils/gtm';
import { getDefaultOfferMap } from '@/utils/purchase';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const InboundJourneyOfferList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inboundData = useSelector(inboundDataSelector);
  const { handleCreatingAndFetchingTripOfferBooking } = useBookingCreation();
  const { hasSelection, booking: manageBooking } = useChangeBookingSelection();

  useEffect(() => {
    if (inboundData.selectedJourney) {
      dispatch(
        setSelectedInboundOfferMapByLegId(
          getDefaultOfferMap(inboundData.selectedJourney)
        )
      );
    }
  }, [dispatch, inboundData.selectedJourney]);

  useEffect(() => {
    if (!inboundData.selectedJourney) {
      navigate('/purchase');
    }
  }, [navigate, inboundData.selectedJourney]);

  return (
    <JourneyOfferList
      title={<TransText i18nKey="selectReturnTicket" />}
      selectedJourney={inboundData.selectedJourney}
      updateSelectedOfferMap={updateSelectedInboundOfferMapByLegId}
      selectedOfferMapByLegIdSelector={selectedInboundOfferMapSelector}
      onContinue={async () => {
        trackCustomEvent(GTM_EVENT.INBOUND_OFFER_CONFIRMED);

        if (hasSelection) {
          // Change-booking commit: see OutboundJourneyOfferList for rationale.
          try {
            await dispatch(startExchange()).unwrap();
            if (manageBooking?.id) {
              await dispatch(
                getManageFlowBookingById(manageBooking.id)
              ).unwrap();
            }
            navigate('/purchase/checkout');
          } catch (err) {
            const errors = (err as ApiErrorResponse).response?.data?.errors;
            if (errors?.length) {
              errors.forEach((e) => toast.error(e.message));
            } else {
              toast.error(<TransAlert i18nKey="startExchangeFailed" />);
            }
          }
          return;
        }

        handleCreatingAndFetchingTripOfferBooking();
      }}
      onGoBack={() => navigate(-1)}
    />
  );
};

export default InboundJourneyOfferList;
